iScreenWizard.controller('MaakFeedbackRondeController', function ($scope, $state, $mdDialog, Ajax, ErrorHandler, Dictionary, userService, Rapporttemplate, nieuwe360FeedbackService) {

    $scope.userService = userService;
    $scope.feedback = nieuwe360FeedbackService.model;
    $scope.rapporttemplates = [];
    $scope.canContinue = false;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        params = {
            wizardfeedbackrapporttype_id: nieuwe360FeedbackService.model.wizardfeedbackrapporttype.id
        };
        Rapporttemplate.all(params).then(function (rapporttemplates) {
            $scope.rapporttemplates = rapporttemplates;
        });
        $scope.checkContinue();
    };

    $scope.checkContinue = function() {
        $scope.canContinue = (typeof $scope.feedback.sessie_titel !== 'undefined' && typeof $scope.feedback.rapporttemplate_id !== 'undefined');
    };

    $scope.maakFeedbackRonde = function() {
        nieuwe360FeedbackService.SaveState();
        if ($scope.canContinue) {
            $state.go('360-feedback/selecteer-testafname');
        }
    };

});